import React, { ReactElement } from "react";

import { TooltipProps } from "antd";

import { Tooltip } from "components";

type TooltipWrapperProps = {
  children: ReactElement;
  className?: string;
  tooltip?: Pick<TooltipProps, "placement" | "title"> | null;
  open?: boolean;
  mRef?: React.RefObject<HTMLSpanElement>;
  style?: React.CSSProperties;
};

export const TooltipWrapper = ({ children, tooltip, open, className, mRef, style }: TooltipWrapperProps) =>
  tooltip ? (
    <Tooltip className={className} style={style} title={tooltip.title as string} placement={tooltip.placement} open={open} mRef={mRef}>
      {children}
    </Tooltip>
  ) : (
    children
  );

export default TooltipWrapper;
